import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import TourDarkSuccessPromotionLabel from './TourDarkSuccessPromotionLabel'
import config from 'constants/config'
import { getTour2027LaunchCampaignTier, isTour2027LaunchCampaignActive } from 'constants/tours'
import { useAppSelector } from 'hooks/reduxHooks'
import { useIntl } from 'react-intl'

interface Props {
  className?: string
  tourId: string
}

function Tour2027TravelTagLabel({ className, tourId }: Props) {
  const intl = useIntl()
  const region = useAppSelector(state => state.geo.currentRegionCode)

  if (!isTour2027LaunchCampaignActive(region, config.BRAND)) {
    return null
  }

  const tier = getTour2027LaunchCampaignTier(tourId, intl)

  if (!tier) {
    return null
  }

  return <TourDarkSuccessPromotionLabel className={className} icon={<LinePlaneDepartureIcon />} variant="default">{tier.tag}</TourDarkSuccessPromotionLabel>
}

export default Tour2027TravelTagLabel
